import {
  Box,
  Button,
  Heading,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  Spinner,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { AiOutlineShoppingCart } from "react-icons/ai";
import {
  IoIosClose,
  IoIosCloseCircle,
  IoIosContact,
  IoIosListBox,
  IoIosSearch,
  IoLogoWhatsapp,
  IoMdChatboxes,
  IoMdSend,
} from "react-icons/io";
import { MdLocalPhone, MdOutlineMail } from "react-icons/md";
import { SiChatbot } from "react-icons/si";
import Mycart from "./myCart";
export const HomeMenu = ({
  conversationStart,
  contactUsMsgSend,
  botDetails,
  currentChatPanelview,
  openCart,
  openChatBot,
  setTrackOrderSearched,
  setIsContactUsMsgSend,
  setCurrentChatPanelview,
  handleContactUs,
  handleTrackOrder,
  isColorDark,
  handleQty,
  mycart,
  trackOrderSearched,
  isloading,
  isConvoHide,
  clickedKnowMoreAboutit,
  sendMessageToBotDirectly,
  handleStartConversation,
  setIsConversationStart,
  error,
  isAskii
}) => {
  const navItems = [
    {
      key: "conversation",
      label: "Conversations",
      icon: IoMdChatboxes,
      action: () =>
        setCurrentChatPanelview(
          // currentChatPanelview === "Home" ? "conversation" : "Home"
          "Home"
        ),
    },
    {
      key: "whatsapp",
      label: "Whatsapp",
      icon: IoLogoWhatsapp,
      action: () => window.open(botDetails?.whatsappRedirectLink, "_blank"),
    },
    {
      key: "trackOrder",
      label: "Track Order",
      icon: IoIosListBox,
      action: () => setCurrentChatPanelview("trackOrder"),
    },
    {
      key: "contactUs",
      label: "Contact",
      icon: IoIosContact,
      action: () => setCurrentChatPanelview("contactUs"),
    },
  ];
  function generateGradientFromColor(
    baseColor,
    steps,
    direction = "to bottom"
  ) {
    const lightenOrDarken = (color, percent) => {
      const num = parseInt(color.slice(1), 16);
      const amt = Math.round(2.55 * percent);
      const R = Math.min(255, Math.max(0, (num >> 16) + amt));
      const G = Math.min(255, Math.max(0, ((num >> 8) & 0x00ff) + amt));
      const B = Math.min(255, Math.max(0, (num & 0x0000ff) + amt));
      return `#${((1 << 24) + (R << 16) + (G << 8) + B).toString(16).slice(1)}`;
    };

    const gradientStops = [];
    const stepSize = 100 / (steps - 1);

    for (let i = 0; i < steps; i++) {
      const lightenPercent = (i / (steps - 1)) * 100; // Gradually increase lightness
      const color =
        i === 0
          ? baseColor // Top stays the base color
          : i === steps - 1
          ? "#FFFFFF" // Bottom is white
          : lightenOrDarken(baseColor, lightenPercent);
      const percentage = (i * stepSize).toFixed(2);
      gradientStops.push(`${color} ${percentage}%`);
    }

    return `linear-gradient(${direction}, ${gradientStops.join(", ")})`;
  }
  // console.log(clickedKnowMoreAboutit,"=========> lcikce nknow moere")
  return (
    <>
      {currentChatPanelview != "conversation" && (
        <Box
          height={"100%"}
          className="homemenu"
          position={"relative"}
          style={{
            backgroundImage: generateGradientFromColor(
              botDetails.accentColor,
              2
            ),
          }}
        >
          {currentChatPanelview != "conversation" && (
            <Box>
              <Box
                display={"flex"}
                pl={"20px"}
                bg={"white"}
                borderTopRadius={"8px"}
                className="chat-bot-head"
                flexDirection={"column"}
                style={{
                  background: "transparent",
                }}
              >
                <Text
                  fontSize={"25px"}
                  // fontWeight={"bold"}
                  color={"black"}
                  mt={"16px"}
                  display={"flex"}
                  justifyContent={"flex-end"}
                  alignItems={"center"}
                >
                  {/* {
                    <BotLogo
                      botDetails={botDetails}
                      isColorDark={isColorDark}
                    />
                  } */}
                  <Box display={"flex"} alignItems={"center"} gap="5px">
                    <AiOutlineShoppingCart
                      onMouseEnter={(e) =>
                        (e.target.style.transform = "scale(1.1)")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.transform = "scale(1)")
                      }
                      style={{ marginRight: "10px", marginBottom: "10px" }}
                      fontSize={"23px"}
                      cursor="pointer"
                      color={
                        isColorDark(botDetails?.accentColor) ? "white" : "black"
                      }
                      onClick={openCart}
                    />
                    {/* <IoIosClose
                      fontSize={"35px"}
                      cursor="pointer"
                      color={isColorDark(botDetails?.accentColor) ? "white" : "black"}
                      onClick={openChatBot}
                    /> */}
                    {!isAskii&&<IoIosCloseCircle
                      fontSize={"26px"}
                      style={{ marginRight: "10px", marginBottom: "10px" }}
                      cursor="pointer"
                      color={
                        isColorDark(botDetails?.accentColor) ? "white" : "black"
                      }
                      onClick={()=>{
                        window.parent.postMessage({ type: "botOpen", botOpen:false }, "*");
                        openChatBot()}}
                    />}
                  </Box>
                </Text>
              </Box>
            </Box>
          )}

          {botDetails.menuSection.search && (
            <Box
              className="menu-buttons"
              display={"flex"}
              m={"2%"}
              bg={"#f4f4f6"}
              py={"15px"}
              pl="10px"
              pr="3px"
              h={"45px"}
              fontSize={"13px"}
              alignItems={"center"}
              borderRadius={"10px"}
              justifyContent={"flex-start"}
            >
              {" "}
              <Box display={"flex"} alignItems={"center"} gap={"8px"}>
                {" "}
                <IoIosSearch /> Search for products ...
              </Box>
            </Box>
          )}

          <Box height={"60%"} overflowY={currentChatPanelview == "mycart"?"scroll":"unset"} >
            <Box>
              <Box display={currentChatPanelview == "contactUs" ? "" : "none"}>
                <Box
                  margin={"18px"}
                  display={"flex"}
                  flexDirection={"column"}
                  // h={"600px"}
                  // border={"1px solid red"}
                  gap={"20px"}
                >
                  {!contactUsMsgSend.isSend ? (
                    <>
                      <form
                        style={{
                          maxWidth: "337px",
                          maxHeight: "380px",
                          border: `1px solid ${botDetails.accentColor}`,
                          padding: "16px",
                          margin: "15px",
                          marginTop: 0,
                          marginBottom: 0,
                          display: "flex",
                          flexDirection: "column",
                          background: "white",
                          gap: "20px",
                          borderRadius: "15px",
                          boxShadow: "rgba(28, 28, 28, 0.2) 0px 5px 12px -3px",
                        }}
                        action=""
                        onSubmit={handleContactUs}
                      >
                        <Heading style={{ color: "black" }}>Contact Us</Heading>
                        <Input
                          placeholder="Full Name"
                          required
                          style={{
                            background: "white",
                            color: "black",
                            fontSize: "16px",
                            padding: "16px",
                            borderRadius: "10px",
                          }}
                          onChange={(e) => {
                            //call api
                        
                      
                            setIsContactUsMsgSend({
                              ...contactUsMsgSend,
                              inputDetails: {
                                ...contactUsMsgSend.inputDetails,
                                fullName: e.target.value,
                              },
                            });
                          }}
                        />
                        <Input
                          placeholder="Email address"
                          type="email"
                          style={{
                            background: "white",
                            color: "black",
                            fontSize: "16px",
                            padding: "16px",
                            borderRadius: "10px",
                          }}
                          required
                          onChange={(e) => {
                            setIsContactUsMsgSend({
                              ...contactUsMsgSend,
                              inputDetails: {
                                ...contactUsMsgSend.inputDetails,
                                email: e.target.value,
                                
                              },
                            });
                          }}
                        />
                        <Textarea
                          placeholder="Write your message here"
                          style={{
                            background: "white",
                            color: "black",
                            fontSize: "16px",
                            // padding: "16px",
                            borderRadius: "10px",
                          }}
                          required
                          onChange={(e) => {
                            setIsContactUsMsgSend({
                              ...contactUsMsgSend,
                              inputDetails: {
                                ...contactUsMsgSend.inputDetails,
                                msg: e.target.value,
                              },
                            });
                          }}
                        />

                        <Button
                          boxShadow="md"
                          style={{
                            textAlign: "center",
                            height: "40px",
                            padding: "10px",
                            width: "100%",
                            marginTop: "10px",

                            cursor: "pointer",
                            fontSize: "15px",
                            borderRadius: "15px",
                            background: botDetails.accentColor,
                            border: `1px solid ${botDetails.accentColor}`,
                            color: isColorDark(botDetails?.accentColor)
                              ? "white"
                              : "black",
                          }}
                          isLoading={isloading}
                          type="submit"
                          onMouseOver={(e) => {
                            e.target.style.border = `1px solid ${botDetails.accentColor}`;
                            e.target.style.background = "white";
                            e.target.style.color = isColorDark(
                              botDetails?.accentColor
                            )
                              ? botDetails.accentColor
                              : "black";
                          }}
                          onMouseOut={(e) => {
                            e.target.style.border = `1px solid ${botDetails.accentColor}`;
                            e.target.style.background = botDetails.accentColor;
                            e.target.style.color = isColorDark(
                              botDetails?.accentColor
                            )
                              ? "white"
                              : "black";
                          }}
                        >
                          Submit
                        </Button>

                        {/* <Button
                          textAlign={"center"}
                          style={{}}
                          h="40px"
                          p={"10px"}
                          width={"100%"}
                          mt="10px"
                          boxShadow="md"
                          cursor={"pointer"}
                          type="submit"
                          fontSize={"15px"}
                          borderRadius={"15px"}
                          isLoading={isloading}
                          bg={botDetails.accentColor}
                          border={`1px solid ${botDetails.accentColor}`}
                          color={
                            isColorDark(botDetails?.accentColor)
                              ? "white"
                              : "black"
                          }
                          _hover={{
                            border: `1px solid ${botDetails.accentColor}`,
                            bg: "white",
                            color: isColorDark(botDetails?.accentColor)
                              ? `${botDetails.accentColor}`
                              : "black",
                          }}
                        >
                          Submit
                        </Button>{" "} */}
                      </form>
                    </>
                  ) : (
                    <>
                      <Text
                        style={{ color: "black" }}
                        fontSize={"16px"}
                        // fontWeight={"bold"}

                        mt={"16px"}
                        display={"flex"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                      >
                        We have received your message
                      </Text>
                      <Text
                        fontSize={"16px"}
                        // fontWeight={"bold"}
                        display={"flex"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                      >
                        Our team is looking into the matter. We will get back to
                        you at the earliest.
                      </Text>
                      <Image
                        mt="20%"
                        w={"60%"}
                        m="auto"
                        src={
                          "https://www.ulai.in/file-server/uploads/Ulai/media/contactUs.8e3762257e38e21fd996.png"
                        }
                      />
                    </>
                  )}
                </Box>
              </Box>
              <Box
                display={currentChatPanelview == "trackOrder" ? "flex" : "none"}
                style={{ justifyContent: "center", alignItems: "center" }}
              >
                {!trackOrderSearched.isSearched ||
                (trackOrderSearched.isSearched &&
                  trackOrderSearched.notFound) ? (
                  <form
                    style={{
                      maxWidth: "337px",
                      height: "366.8px",
                      margin: "15px",
                      marginTop: 0,
                      marginBottom: 0,
                      display: "flex",
                      background: "white",
                      flexDirection: "column",
                      gap: "20px",
                      boxShadow: "rgba(28, 28, 28, 0.2) 0px 5px 12px -3px",
                      padding: "16px",
                      borderRadius: "15px",
                      border: `1px solid ${botDetails.accentColor}`,
                    }}
                    onSubmit={handleTrackOrder}
                  >
                    <Heading style={{ color: "black" }}>Track Order</Heading>
                    <label>
                      Order Number
                      <Input
                        placeholder="Eg. #112233"
                        mt="8px"
                        required
                        style={{
                          background: "white",
                          color: "black",
                          fontSize: "16px",
                          padding: "16px",
                          borderRadius: "10px",
                        }}
                        name="orderNo"
                        onChange={(e) => {
                          setTrackOrderSearched({
                            ...trackOrderSearched,
                            isSearched: false,
                            notFound: false,
                            inputDetails: {
                              ...trackOrderSearched.inputDetails,
                              orderNo: e.target.value,
                            },
                          });
                        }}
                      />
                    </label>
                    <label>
                      Email ID or Phone Number
                      <Input
                        placeholder="Email ID or Phone Number"
                        mt="8px"
                        required
                        style={{
                          background: "white",
                          color: "black",
                          fontSize: "16px",
                          padding: "16px",
                          borderRadius: "10px",
                        }}
                        name="email/phone"
                        onChange={(e) => {
                          setTrackOrderSearched({
                            ...trackOrderSearched,
                            isSearched: false,
                            notFound: false,
                            inputDetails: {
                              ...trackOrderSearched.inputDetails,
                              phoneOrEmail: e.target.value,
                            },
                          });
                        }}
                      />
                    </label>
                    <Text
                      fontSize={"16px"}
                      // fontWeight={"bold"}
                      color={"#a43c3c"}
                      mt={"2px"}
                      display={"flex"}
                      justifyContent={"center"}
                      gap={"10px"}
                      alignItems={"flex-start"}
                      alignContent={"flex-start"}
                      // alignItems={"center"}
                    >
                      {trackOrderSearched.isSearched &&
                        trackOrderSearched.notFound && (
                          <>
                            <Box mt={"5px"}>
                            {!isAskii&& <IoIosCloseCircle
                                fontSize={"18px"}
                                color="red"
                                // pt="20px"
                              />}
                            </Box>{" "}
                            <Box>
                              {" "}
                              Could not find matching order number. <br />
                              Please try again.
                            </Box>
                          </>
                        )}
                    </Text>
                    <Button
                      style={{
                        textAlign: "center",
                        height: "40px",
                        padding: "10px",
                        width: "100%",
                        marginTop: "10px",

                        cursor: "pointer",
                        fontSize: "15px",
                        borderRadius: "15px",
                        background: botDetails.accentColor,
                        border: `1px solid ${botDetails.accentColor}`,
                        color: isColorDark(botDetails?.accentColor)
                          ? "white"
                          : "black",
                      }}
                      isLoading={isloading}
                      type="submit"
                      boxShadow="md"
                      _hover={{
                        border: `1px solid ${botDetails.accentColor}`,
                        bg: "white",
                        color: isColorDark(botDetails?.accentColor)
                          ? `${botDetails.accentColor}`
                          : "black",
                      }}
                    >
                      View Order Status
                    </Button>
                    {/* {currentChatPanelview != "Home" &&
                    currentChatPanelview != "mycart" ? (
                      <Box width={"100%"} bottom={40}>
                        <Button
                          display={
                            currentChatPanelview == "Home" || isConvoHide
                              ? "none"
                              : "Flex"
                          }
                          textAlign={"center"}
                          h="40px"
                          p={"10px"}
                          width={"100%"}
                          mt="10px"
                          boxShadow="md"
                          cursor={"pointer"}
                          type="submit"
                          fontSize={"15px"}
                          borderRadius={"15px"}
                          isLoading={isloading}
                          bg={botDetails.accentColor}
                          border={`1px solid ${botDetails.accentColor}`}
                          color={
                            isColorDark(botDetails?.accentColor)
                              ? "white"
                              : "black"
                          }
                          _hover={{
                            border: `1px solid ${botDetails.accentColor}`,
                            bg: "white",
                            color: isColorDark(botDetails?.accentColor)
                              ? `${botDetails.accentColor}`
                              : "black",
                          }}
                          onClick={() => {
                            conversationStart.isStart
                              ? clickedKnowMoreAboutit.isClicked
                                ? sendMessageToBotDirectly(
                                    clickedKnowMoreAboutit.text
                                  )
                                : setCurrentChatPanelview("conversation")
                              : setCurrentChatPanelview("Home");
                          }}
                     
                        >
                       
                          {conversationStart.isStart
                            ? "Resume conversation"
                            : "Send us a message"}
                       
                        </Button>
                      </Box>
                    ) : (
                      <></>
                    )} */}
                  </form>
                ) : (
                  <Box
                    m={"8%"}
                    display={"flex"}
                    flexDirection={"column"}
                    gap="10px"
                    color={
                      isColorDark(botDetails?.accentColor)
                        ? botDetails?.accentColor
                        : "black"
                    }
                  >
                    <Text fontSize={"18px"}>
                      Your Order No #{trackOrderSearched.detail.orderNo}
                    </Text>
                    <Text fontSize={"18px"}>
                      Status : {trackOrderSearched.detail.status}
                    </Text>
                    {trackOrderSearched.detail.trackLink && (
                      <Text fontSize={"18px"}>
                        Track Link :{" "}
                        <Button
                          size="md"
                          style={{
                            background: botDetails.accentColor,
                            border: `1px solid ${botDetails.accentColor}`,
                            color: isColorDark(botDetails?.accentColor)
                              ? "white"
                              : "black",
                            height: "30px",
                          }}
                          _hover={{
                            border: `1px solid ${botDetails.accentColor}`,
                            bg: `white`,
                            color: isColorDark(botDetails?.accentColor)
                              ? botDetails?.accentColor
                              : "black",
                          }}
                          onClick={() => {
                            window.open(
                              `${trackOrderSearched.detail.trackLink}`,
                              "_blank"
                            );
                          }}
                        >
                          {/* <a
                             
                             
                            > */}{" "}
                          Click Here
                          {/* </a> */}
                        </Button>
                      </Text>
                    )}
                    <Image
                      mt="20px"
                      src={
                        "https://www.ulai.in/file-server/uploads/Ulai/media/2791566.b68ea809fc6579995e73.png"
                      }
                    />
                  </Box>
                )}
              </Box>{" "}
              <Box
                display={currentChatPanelview == "mycart" ? "" : "none"}
                className="ui-trackOrderPanel"
                height={"380px"}
              >
                {!isloading ? (
                  <Mycart
                    botDetails={botDetails}
                    isColorDark={isColorDark}
                    handleQty={handleQty}
                    mycart={mycart}
                  />
                ) : (
                  <Box
                    display={"flex"}
                    justifyContent={"center"}
                    marginTop={"2"}
                  >
                    <Spinner
                      color={
                        isColorDark(botDetails?.accentColor)
                          ? botDetails?.accentColor
                          : "black"
                      }
                      fontSize={"16px"}
                    />
                  </Box>
                )}
              </Box>{" "}
            </Box>

            {/* {currentChatPanelview != "Home" &&
            currentChatPanelview != "mycart" ? (
              <></>
            ) : 
            currentChatPanelview == "mycart" ? (
              <Box
                position={"sticky"}
                bottom={"2%"}
                boxShadow="0 -2px 6px rgba(0, 0, 0, 0.1)"
              >
                {mycart?.items && mycart?.items.length != 0 && (
                  <Box
                    display={"flex"}
                    justifyContent={"space-around"}
                    background={"white"}
                  >
                    {" "}
                    <span>Total</span>
                    <span>
                      {mycart?.currency == "INR" && "Rs. "}{" "}
                      {isloading ? (
                        <Spinner
                          color={
                            isColorDark(botDetails?.accentColor)
                              ? botDetails?.accentColor
                              : "black"
                          }
                          // marginTop={"2px"}
                          fontSize={"16px"}
                        />
                      ) : (
                        Number(
                          `${mycart?.total_price
                            ?.toString()
                            ?.slice(
                              0,
                              mycart?.total_price?.toString()?.length - 2
                            )}.${mycart?.total_price?.toString()?.slice(-2)}`
                        )
                      )}
                    </span>{" "}
                  </Box>
                )}
                {mycart?.lineItems && mycart?.lineItems.physicalItems != 0 && (
                  <Box
                    display={"flex"}
                    justifyContent={"space-around"}
                    background={"white"}
                  >
                    {" "}
                    <span>Total</span>
                    <span>
                      {mycart?.currency.code == "INR" && "Rs. "}{" "}
                      {isloading ? (
                        <Spinner
                          color={
                            isColorDark(botDetails?.accentColor)
                              ? botDetails?.accentColor
                              : "black"
                          }
                          // marginTop={"2px"}
                          fontSize={"16px"}
                        />
                      ) : (
                        mycart?.cartAmount
                      )}
                    </span>{" "}
                  </Box>
                )}
                {mycart?.lineItems && mycart?.lineItems.physicalItems != 0 ? (
                  <Button
                    style={{
                      background: "white",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "5px 0px",
                      margin: "8px",
                      width: "95%",
                      fontSize: "15px",
                      borderRadius: "8px",
                      boxShadow: "md",
                      background: botDetails.accentColor,
                      border: `1px solid ${botDetails.accentColor}`,
                      color: isColorDark(botDetails?.accentColor)
                        ? "white"
                        : "black",
                      height: "30px",
                      gap: "10px",
                    }}
                    onClick={() => {
                      const cartPath =
                        botDetails.storeName === "Bigcommerce"
                          ? "/checkout.php"
                          : botDetails.storeName === "Shopify"
                          ? "/checkout"
                          : "";
                      window.location.href = cartPath;
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.border = `1px solid ${botDetails.accentColor}`;
                      e.target.style.background = "white";
                      e.target.style.color = isColorDark(
                        botDetails?.accentColor
                      )
                        ? botDetails?.accentColor
                        : "black";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.border = `1px solid ${botDetails.accentColor}`;
                      e.target.style.background = botDetails.accentColor;
                      e.target.style.color = isColorDark(
                        botDetails?.accentColor
                      )
                        ? "white"
                        : "black";
                    }}
                  >
                    Checkout
                  </Button>
                ) : (
                  <></>
                  // <Button
                  //   alignItems={"center"}
                  //   justifyContent={"center"}
                  //   p={"5px 0px"}
                  //   m="8px"
                  //   w={"95%"}
                  //   fontSize={"15px"}
                  //   borderRadius={"8px"}
                  //   boxShadow="md"
                  //   bg={botDetails.accentColor}
                  //   border={`1px solid ${botDetails.accentColor}`}
                  //   color={
                  //     isColorDark(botDetails?.accentColor) ? "white" : "black"
                  //   }
                  //   h="30px"
                  //   _hover={{
                  //     border: `1px solid ${botDetails.accentColor}`,
                  //     bg: `white`,
                  //     color: isColorDark(botDetails?.accentColor)
                  //       ? botDetails?.accentColor
                  //       : "black",
                  //   }}
                  //   gap={"10px"}
                  //   onClick={() => {
                  //     conversationStart.isStart
                  //       ? clickedKnowMoreAboutit.isClicked
                  //         ? sendMessageToBotDirectly(
                  //             clickedKnowMoreAboutit.text
                  //           )
                  //         : setCurrentChatPanelview("conversation")
                  //       : setCurrentChatPanelview("Home");
                  //   }}
                  //   // w={"100%"}
                  // >
                  //   Resume conversation
                  // </Button>
                )}
                {mycart?.items && mycart?.items.length != 0 ? (
                  <Button
                    style={{
                      background: botDetails.accentColor,
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "5px 0px",
                      margin: "8px",
                      width: "95%",
                      fontSize: "15px",
                      borderRadius: "8px",
                      boxShadow: "md",
                      border: `1px solid ${botDetails.accentColor}`,
                      color: isColorDark(botDetails?.accentColor)
                        ? "white"
                        : "black",
                      height: "30px",
                      gap: "10px",
                    }}
                    _hover={{
                      border: `1px solid ${botDetails.accentColor}`,
                      bg: `white`,
                      color: isColorDark(botDetails?.accentColor)
                        ? botDetails?.accentColor
                        : "black",
                    }}
                    onClick={() => {
                      const cartPath =
                        botDetails.storeName === "Bigcommerce"
                          ? "/checkout.php"
                          : botDetails.storeName === "Shopify"
                          ? "/checkout"
                          : "";
                      window.location.href = cartPath;
                    }}
                    // w={"100%"}
                  >
                    Checkout
                  </Button>
                ) : (
                  <></>
                  // <Button
                  //   alignItems={"center"}
                  //   justifyContent={"center"}
                  //   p={"5px 0px"}
                  //   m="8px"
                  //   w={"95%"}
                  //   fontSize={"15px"}
                  //   borderRadius={"8px"}
                  //   boxShadow="md"
                  //   bg={botDetails.accentColor}
                  //   border={`1px solid ${botDetails.accentColor}`}
                  //   color={
                  //     isColorDark(botDetails?.accentColor) ? "white" : "black"
                  //   }
                  //   h="30px"
                  //   _hover={{
                  //     border: `1px solid ${botDetails.accentColor}`,
                  //     bg: `white`,
                  //     color: isColorDark(botDetails?.accentColor)
                  //       ? botDetails?.accentColor
                  //       : "black",
                  //   }}
                  //   gap={"10px"}
                  //   onClick={() => {
                  //     conversationStart.isStart
                  //       ? clickedKnowMoreAboutit.isClicked
                  //         ? sendMessageToBotDirectly(
                  //             clickedKnowMoreAboutit.text
                  //           )
                  //         : setCurrentChatPanelview("conversation")
                  //       : setCurrentChatPanelview("Home");
                  //   }}
                  //   // w={"100%"}
                  // >
                  //   Resume conversation
                  // </Button>
                )}
              </Box>
            ) : (
              <></>
            )} */}

            {botDetails.askDetailsBeforeChat ? (
              <Box
                display={currentChatPanelview == "Home" ? "" : "none"}
                mt={0}
                m={4}
                mb={0}
                className="ui-askDetailsBeforeChat"
            
              >
                {" "}
                {!conversationStart.isStart ? (
                  <>
                    <Box style={{ padding: 0, paddingTop: 0 }}>
                      {/* First Box with Text, Bot Icon, and Button */}
                      <h6
                        style={{
                          fontSize: "2rem",
                          fontWeight: "bold",
                          marginBottom: "16px",
                          lineHeight: "36px",
                          textTransform: "none",
                          color: isColorDark(botDetails?.accentColor)
                            ? "white"
                            : "black",
                        }}
                      >
                        {botDetails.botName}
                      </h6>
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        boxShadow="0 4px 10px rgba(0, 0, 0, 0.1)"
                        borderRadius="15px"
                        border={`1px solid ${
                          isColorDark(botDetails?.accentColor)
                            ? "white"
                            : "black"
                        }`}
                        style={{
                          width: "100%",
                          background: "white",
                          padding: "20px",
                          height: "auto",
                          transition: "all 0.3s ease-in-out", // Smooth transition for hover effects
                        }}
                      >
                        {/* Second Box with Text on the Right and Bot Icon on the Left */}
                        <Box
                          display="flex"
                          gap={4}
                          alignItems="center"
                          width="100%"
                          mb={3}
                        >
                          {/* Left Side (Bot Icon) */}
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            color={
                              isColorDark(botDetails.accentColor)
                                ? "black"
                                : "white"
                            }
                            borderRadius="50%"
                            p="10px"
                            boxShadow="0 2px 5px rgba(0, 0, 0, 0.1)"
                          >
                            <SiChatbot size="40px" color={"black"} />
                          </Box>

                          {/* Right Side (Text) */}
                          <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="flex-start"
                          >
                            <Text
                              fontSize="16px"
                              fontWeight="bold"
                              color={"black"}
                              mb={1}
                            >
                              AI Powered Chat
                            </Text>
                            <Text fontSize="16px" color={"black"} opacity="0.8">
                              {botDetails.subheading}
                            </Text>
                          </Box>
                        </Box>
                        <form
                          action=""
                          onSubmit={(e) => {
                            handleStartConversation(e);
                            // window.parent.postMessage({ type: "boxHeight", boxHeight:(window.innerHeight-65) }, "*");
                          }}
                          style={{ marginTop: 0 }}
                        >
                          {botDetails.askEmail && (
                            <Box className="ui-askemailAuth" mt={"15px"}>
                              <InputGroup style={{ marginBottom: 4 }}>
                                <Input
                                  placeholder="Enter your email"
                                  type="email"
                                  style={{
                                    background: "white",
                                    color: "black",
                                    fontSize: "16px",
                                    padding: "17px",
                                    paddingLeft: "40px", // Adjust padding to account for the left element
                                    borderRadius: "10px",
                                  }}
                                  required
                                  onChange={(e) => {
                                    // email start
                                
                                    setIsConversationStart({
                                      ...conversationStart,
                                      inputDetails: {
                                        ...conversationStart.inputDetails,
                                        email: e.target.value,
                                        clickedKnowMoreAboutit
                                      },
                                    });
                                  }}
                                />
                                <InputLeftElement
                                  style={{
                                    position: "absolute",
                                    height: "100%", // Make sure it spans the entire height of the input
                                    marginRight: "7px", // Apply right margin
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    pointerEvents: "none", // Ensure it's non-interactive
                                  }}
                                >
                                  <MdOutlineMail
                                    style={{
                                      color: "#a6a6a6",
                                      fontSize: "20px", // Adjust icon size
                                    }}
                                  />
                                </InputLeftElement>
                              </InputGroup>
                            </Box>
                          )}
                          {botDetails.askPhone && (
                            <Box
                              display={
                                currentChatPanelview == "Home" ? "" : "none"
                              }
                              className="ui-askPhone"
                            >
                              <InputGroup style={{ marginBottom: 4 }}>
                                <Input
                                  placeholder="Enter phone no"
                                  type="number"
                                  style={{
                                    background: "white",
                                    color: "black",
                                    fontSize: "16px",
                                    padding: "17px",
                                    paddingLeft: "40px", // Adjust padding to account for the left element
                                    borderRadius: "10px",
                                  }}
                                  required
                                  onChange={(e) => {
                                  
                                    setIsConversationStart({
                                      ...conversationStart,
                                      inputDetails: {
                                        
                                        ...conversationStart.inputDetails,
                                        phone: e.target.value,

                                      },
                                    });
                                  }}
                                />
                                <InputLeftElement
                                  style={{
                                    position: "absolute",
                                    height: "100%", // Make sure it spans the entire height of the input
                                    marginRight: "7px", // Apply right margin
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    pointerEvents: "none", // Ensure it's non-interactive
                                  }}
                                >
                                  <MdLocalPhone
                                    style={{
                                      color: "#a6a6a6",
                                      fontSize: "20px", // Adjust icon size
                                    }}
                                  />
                                </InputLeftElement>
                              </InputGroup>

                              {error ? (
                                <p style={{ color: "red" }}>
                                  Mobile number should be 10 digits
                                </p>
                              ) : null}
                            </Box>
                          )}

                          <Button
                            style={{
                              textAlign: "center",
                              height: "40px",
                              padding: "10px",
                              marginTop: "10px",
                              width: "100%",
                              boxShadow: "md",
                              cursor: "pointer",
                              fontSize: "15px",
                              borderRadius: "15px",
                              border: `1px solid ${
                                isColorDark(botDetails?.accentColor)
                                  ? "white"
                                  : "black"
                              }`,
                              background: botDetails.accentColor,
                              color: isColorDark(botDetails?.accentColor)
                                ? "white"
                                : "black",
                            }}
                            type="submit"
                            isLoading={isloading}
                            _hover={{
                              border: `1px solid ${botDetails.accentColor}`,
                              background: "white",
                              color: isColorDark(botDetails?.accentColor)
                              ? botDetails.accentColor
                              : "black",
                            }}
                          >
                            <Text style={{ marginRight: "4px",border:"none",background:"transparent" }}>
                              Start Chat
                            </Text>
                            <IoMdSend fontSize={"19px"}style={{border:"none",background:"transparent"}} onClick={()=>{
                              // console.log(botDetails,"=======+>Dfdffd")
                            }} />
                          </Button>

                          {/* <CustomButton
                              IoIosSearch={IoMdSend}
                              w="110px"
                              text="Start Chat"
                              // onClick={() => {
                              //   setCurrentChatPanelview("conversation");
                              // }}
                            /> */}
                        </form>

                        {/* Button */}
                      </Box>

                      {/* <Button
                  display={"flex"}
                  justifyContent="flex-start"
                  alignItems={"center"}
                  variant="ghost"
                  rihtIcon={<IoIosListBox />}
                  leftIcon={<AiOutlineShoppingCart />}
                  width="100%"
                  onClick={() => {
                    openCart();
                  }}
                  style={{
                    height: "48px",
                    background: "white",
                    borderRadius: "6px",
                    marginTop: "10px",
                  }}
                >
                  Cart
                </Button> */}
                    </Box>
                  </>
                ) : (
                  <>
                    <Box
                      border={
                        isColorDark(botDetails?.accentColor)
                          ? `1px solid ${botDetails.accentColor}`
                          : `1px solid black`
                      }
                      bg={botDetails.accentColor}
                      color={
                        isColorDark(botDetails?.accentColor) ? "white" : "black"
                      }
                      _hover={{
                        border: isColorDark(botDetails?.accentColor)
                          ? `1px solid ${botDetails.accentColor}`
                          : `1px solid black`,
                        bg: "white",
                        color: isColorDark(botDetails?.accentColor)
                          ? botDetails?.accentColor
                          : "black",
                      }}
                      borderRadius={"12px"}
                      p={"19px"}
                      cursor={"pointer"}
                      onClick={() => {
                        clickedKnowMoreAboutit.isClicked
                          ? sendMessageToBotDirectly(
                              clickedKnowMoreAboutit.text
                            )
                          : setCurrentChatPanelview("conversation");
                      }}
                    >
                      {" "}
                      Resume your conversation ...
                    </Box>
                    <Image
                      src={"https://i.ibb.co/QnbR10f/chat-Resume.webp"}
                      mt="25%"
                    />
                  </>
                )}
              </Box>
            ) : !conversationStart.isStart && currentChatPanelview == "Home" ? (
              <Box style={{ padding: 16, paddingTop: 0 }}>
                {/* First Box with Text, Bot Icon, and Button */}
                <h6
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginBottom: "16px",
                    lineHeight: "36px",
                    textTransform: "none",
                    color: isColorDark(botDetails?.accentColor)
                      ? "white"
                      : "black",
                  }}
                >
                  {botDetails.botName}
                </h6>
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  boxShadow="0 4px 10px rgba(0, 0, 0, 0.1)"
                  borderRadius="15px"
                  border={`1px solid ${botDetails.accentColor}`}
                  style={{
                    width: "100%",
                    background: "white",
                    padding: "20px",
                    height: "auto",
                    transition: "all 0.3s ease-in-out", // Smooth transition for hover effects
                  }}
                >
                  {/* Second Box with Text on the Right and Bot Icon on the Left */}
                  <Box
                    display="flex"
                    gap={4}
                    alignItems="center"
                    width="100%"
                    mb={3}
                  >
                    {/* Left Side (Bot Icon) */}
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      color={
                        isColorDark(botDetails.accentColor) ? "black" : "white"
                      }
                      borderRadius="50%"
                      p="10px"
                      boxShadow="0 2px 5px rgba(0, 0, 0, 0.1)"
                    >
                      <SiChatbot size="40px" color={"black"} />
                    </Box>

                    {/* Right Side (Text) */}
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="flex-start"
                    >
                      <Text
                        fontSize="16px"
                        fontWeight="bold"
                        color={"black"}
                        mb={1}
                      >
                        AI Powered Chat
                      </Text>
                      <Text fontSize="16px" color={"black"} opacity="0.8">
                        {botDetails.subheading}
                      </Text>
                    </Box>
                  </Box>

                  {/* Button */}
                  <Box width="100%">
                    <Button
                      style={{
                        padding: "15px",
                        height: "50px",
                        fontSize: "16px",
                        fontWeight: "600",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        color: isColorDark(botDetails?.accentColor)
                          ? "white"
                          : "black",
                        background: isColorDark(botDetails?.accentColor)
                          ? botDetails.accentColor
                          : "white",
                        border: `2px solid ${
                          isColorDark(botDetails?.accentColor)
                            ? "transparent"
                            : botDetails.accentColor
                        }`,
                        borderRadius: "8px",
                        transition: "all 0.2s ease-in-out",
                      }}
                      isLoading={isloading}
                      _hover={{
                        borderColor: `${botDetails.accentColor}`,
                        background: `${botDetails.accentColor}`,
                        color: "white",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                      }}
                      _active={{
                        transform: "scale(0.98)", // Button press effect
                      }}
                      onClick={() => {
                        setIsConversationStart({
                          ...conversationStart,
                          isStart: true,
                        });
                        clickedKnowMoreAboutit.isClicked
                          ? sendMessageToBotDirectly(
                              clickedKnowMoreAboutit.text
                            )
                          : setCurrentChatPanelview("conversation");
                      }}
                    >
                      <Text>Start Chat</Text>
                      <IoMdSend fontSize="20px" />
                    </Button>
                  </Box>
                </Box>

                {/* <Button
                  display={"flex"}
                  justifyContent="flex-start"
                  alignItems={"center"}
                  variant="ghost"
                  rihtIcon={<IoIosListBox />}
                  leftIcon={<AiOutlineShoppingCart />}
                  width="100%"
                  onClick={() => {
                    openCart();
                  }}
                  style={{
                    height: "48px",
                    background: "white",
                    borderRadius: "6px",
                    marginTop: "10px",
                  }}
                >
                  Cart
                </Button> */}
              </Box>
            ) : conversationStart.isStart && currentChatPanelview == "Home" ? (
              <>
                <Box
                  border={
                    isColorDark(botDetails?.accentColor)
                      ? `1px solid ${botDetails.accentColor}`
                      : `1px solid black`
                  }
                  color={
                    isColorDark(botDetails?.accentColor)
                      ? botDetails?.accentColor
                      : "black"
                  }
                  _hover={{
                    border: isColorDark(botDetails?.accentColor)
                      ? `1px solid ${botDetails.accentColor}`
                      : `1px solid black`,
                    bg: "white",
                    color: isColorDark(botDetails?.accentColor)
                      ? botDetails?.accentColor
                      : "black",
                  }}
                  borderRadius={"12px"}
                  p={"15px"}
                  cursor={"pointer"}
                  m={"8%"}
                  onClick={() => {
                    clickedKnowMoreAboutit.isClicked
                      ? sendMessageToBotDirectly(clickedKnowMoreAboutit.text)
                      : setCurrentChatPanelview("conversation");
                  }}
                >
                  {" "}
                  Resume your conversation ...
                </Box>
                <Image
                  src={"https://i.ibb.co/QnbR10f/chat-Resume.webp"}
                  mt="8%"
                />
              </>
            ) : (
              <></>
            )}
          </Box>

          <Box
            padding={"16px"}
            bottom={10}
            position={"absolute"}
            width={"100%"}
          >
                  {currentChatPanelview != "Home" &&
            currentChatPanelview != "mycart" ? (
              <></>
            ) : 
            currentChatPanelview == "mycart" ? (
              <Box
                position={"relative"}
                bottom={"80px"}
                boxShadow="0 -2px 6px rgba(0, 0, 0, 0.1)"
              >
                {mycart?.items && mycart?.items.length != 0 && (
                  <Box
                    display={"flex"}
                    justifyContent={"space-around"}
                    background={"white"}
                  >
                    {" "}
                    <span>Total</span>
                    <span>
                      {mycart?.currency == "INR" && "Rs. "}{" "}
                      {isloading ? (
                        <Spinner
                          color={
                            isColorDark(botDetails?.accentColor)
                              ? botDetails?.accentColor
                              : "black"
                          }
                          // marginTop={"2px"}
                          fontSize={"16px"}
                        />
                      ) : (
                        Number(
                          `${mycart?.total_price
                            ?.toString()
                            ?.slice(
                              0,
                              mycart?.total_price?.toString()?.length - 2
                            )}.${mycart?.total_price?.toString()?.slice(-2)}`
                        )
                      )}
                    </span>{" "}
                  </Box>
                )}
                {mycart?.lineItems && mycart?.lineItems.physicalItems != 0 && (
                  <Box
                    display={"flex"}
                    justifyContent={"space-around"}
                    background={"white"}
                  >
                    {" "}
                    <span>Total</span>
                    <span>
                      {mycart?.currency.code == "INR" && "Rs. "}{" "}
                      {isloading ? (
                        <Spinner
                          color={
                            isColorDark(botDetails?.accentColor)
                              ? botDetails?.accentColor
                              : "black"
                          }
                          // marginTop={"2px"}
                          fontSize={"16px"}
                        />
                      ) : (
                        mycart?.cartAmount
                      )}
                    </span>{" "}
                  </Box>
                )}
                {mycart?.lineItems && mycart?.lineItems.physicalItems != 0 ? (
                  <Button
                    style={{
                      background: "white",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "5px 0px",
                      margin: "8px",
                      width: "95%",
                      fontSize: "15px",
                      borderRadius: "8px",
                      boxShadow: "md",
                      background: botDetails.accentColor,
                      border: `1px solid ${botDetails.accentColor}`,
                      color: isColorDark(botDetails?.accentColor)
                        ? "white"
                        : "black",
                      height: "30px",
                      gap: "10px",
                    }}
                    onClick={() => {
                      const cartPath =
                      botDetails.storeName === "Bigcommerce"
                        ? "/checkout.php"
                        : botDetails.storeName === "Shopify"
                        ? "/checkout"
                        : "";
                      window.parent.postMessage({ type: "checkoutHref",cartPath }, "*");
                      
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.border = `1px solid ${botDetails.accentColor}`;
                      e.target.style.background = "white";
                      e.target.style.color = isColorDark(
                        botDetails?.accentColor
                      )
                        ? botDetails?.accentColor
                        : "black";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.border = `1px solid ${botDetails.accentColor}`;
                      e.target.style.background = botDetails.accentColor;
                      e.target.style.color = isColorDark(
                        botDetails?.accentColor
                      )
                        ? "white"
                        : "black";
                    }}
                  >
                    Checkout
                  </Button>
                ) : (
                  <></>
                  // <Button
                  //   alignItems={"center"}
                  //   justifyContent={"center"}
                  //   p={"5px 0px"}
                  //   m="8px"
                  //   w={"95%"}
                  //   fontSize={"15px"}
                  //   borderRadius={"8px"}
                  //   boxShadow="md"
                  //   bg={botDetails.accentColor}
                  //   border={`1px solid ${botDetails.accentColor}`}
                  //   color={
                  //     isColorDark(botDetails?.accentColor) ? "white" : "black"
                  //   }
                  //   h="30px"
                  //   _hover={{
                  //     border: `1px solid ${botDetails.accentColor}`,
                  //     bg: `white`,
                  //     color: isColorDark(botDetails?.accentColor)
                  //       ? botDetails?.accentColor
                  //       : "black",
                  //   }}
                  //   gap={"10px"}
                  //   onClick={() => {
                  //     conversationStart.isStart
                  //       ? clickedKnowMoreAboutit.isClicked
                  //         ? sendMessageToBotDirectly(
                  //             clickedKnowMoreAboutit.text
                  //           )
                  //         : setCurrentChatPanelview("conversation")
                  //       : setCurrentChatPanelview("Home");
                  //   }}
                  //   // w={"100%"}
                  // >
                  //   Resume conversation
                  // </Button>
                )}
                {mycart?.items && mycart?.items.length != 0 ? (
                  <Button
                    style={{
                      background: botDetails.accentColor,
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "5px 0px",
                      margin: "8px",
                      width: "95%",
                      fontSize: "15px",
                      borderRadius: "8px",
                      boxShadow: "md",
                      border: `1px solid ${botDetails.accentColor}`,
                      color: isColorDark(botDetails?.accentColor)
                        ? "white"
                        : "black",
                      height: "30px",
                      gap: "10px",
                    }}
                    _hover={{
                      border: `1px solid ${botDetails.accentColor}`,
                      bg: `white`,
                      color: isColorDark(botDetails?.accentColor)
                        ? botDetails?.accentColor
                        : "black",
                    }}
                    onClick={() => {
                      const cartPath =
                      botDetails.storeName === "Bigcommerce"
                        ? "/checkout.php"
                        : botDetails.storeName === "Shopify"
                        ? "/checkout"
                        : "";
                      window.parent.postMessage({ type: "checkoutHref",cartPath }, "*");
                    }}
                    // w={"100%"}
                  >
                    Checkout
                  </Button>
                ) : (
                  <></>
                  // <Button
                  //   alignItems={"center"}
                  //   justifyContent={"center"}
                  //   p={"5px 0px"}
                  //   m="8px"
                  //   w={"95%"}
                  //   fontSize={"15px"}
                  //   borderRadius={"8px"}
                  //   boxShadow="md"
                  //   bg={botDetails.accentColor}
                  //   border={`1px solid ${botDetails.accentColor}`}
                  //   color={
                  //     isColorDark(botDetails?.accentColor) ? "white" : "black"
                  //   }
                  //   h="30px"
                  //   _hover={{
                  //     border: `1px solid ${botDetails.accentColor}`,
                  //     bg: `white`,
                  //     color: isColorDark(botDetails?.accentColor)
                  //       ? botDetails?.accentColor
                  //       : "black",
                  //   }}
                  //   gap={"10px"}
                  //   onClick={() => {
                  //     conversationStart.isStart
                  //       ? clickedKnowMoreAboutit.isClicked
                  //         ? sendMessageToBotDirectly(
                  //             clickedKnowMoreAboutit.text
                  //           )
                  //         : setCurrentChatPanelview("conversation")
                  //       : setCurrentChatPanelview("Home");
                  //   }}
                  //   // w={"100%"}
                  // >
                  //   Resume conversation
                  // </Button>
                )}
              </Box>
            ) : (
              <></>
            )}
            <Box
              position="absolute"
              bottom="2px"
              width="100%"
              px="16px"
              marginLeft={"-10px"}
            >
              <Box
                display="flex"
                bg="#ffffff"
                py="14px"
                px="10px"
                width={"100%"}
                borderRadius="24px"
                alignItems="center"
                justifyItems={"center"}
                textAlign={"center"}
                justifyContent="space-between"
                boxShadow="0px 6px 14px rgba(0, 0, 0, 0.1)"
              >
                {navItems.map(({ key, label, icon: Icon, action }) =>
                  botDetails.menuSection[key] ? (
                    <Box
                      key={key}
                      display="flex"
                      width={"100%"}
                      flexDirection="column"
                      alignItems="center"
                      cursor="pointer"
                      transition="0.3s ease-in-out"
                      onClick={action}
                      _hover={{ transform: "scale(1.05)" }}
                    >
                      <Icon
                        size={26}
                        color={
                          currentChatPanelview === key ? "#007AFF" : "#555"
                        }
                      />
                      <Text
                        fontSize="12px"
                        fontWeight={
                          currentChatPanelview === key ? "bold" : "normal"
                        }
                        color={
                          currentChatPanelview === key ? "#007AFF" : "#777"
                        }
                        mt="4px"
                      >
                        {label}
                      </Text>
                    </Box>
                  ) : null
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};
